// Canned notes for the "Send to spec queue" drawer (migration 20261102130000).
// Managed in Agents → Note templates; the drawer's dropdown copies a body into
// the note textarea, so a job keeps whatever text it was actually sent with.

import type { SupabaseClient } from '@supabase/supabase-js';
import { supabase } from './supabase';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type LooseClient = SupabaseClient<any, 'public', any>;
const db = supabase as unknown as LooseClient;

export type NoteTemplate = {
  id: string;
  name: string;
  body: string;
  created_by: string | null;
  created_at: string;
  updated_at: string;
};

export async function fetchNoteTemplates(): Promise<NoteTemplate[]> {
  const { data, error } = await db.from('spec_note_templates').select('*').order('name');
  if (error) throw error;
  return (data || []) as NoteTemplate[];
}

export async function saveNoteTemplate(id: string | null, input: { name: string; body: string }, createdBy: string | null): Promise<NoteTemplate> {
  const name = input.name.trim();
  if (!name) throw new Error('Give the template a name');
  const query = id
    ? db.from('spec_note_templates').update({ name, body: input.body, updated_at: new Date().toISOString() }).eq('id', id)
    : db.from('spec_note_templates').insert({ name, body: input.body, created_by: createdBy });
  const { data, error } = await query.select('*').single();
  if (error) throw error;
  return data as NoteTemplate;
}

export async function deleteNoteTemplate(id: string): Promise<void> {
  const { error } = await db.from('spec_note_templates').delete().eq('id', id);
  if (error) throw error;
}
